export default () => {
  const availableFilters = () => [];

  return { availableFilters };
};
